<div class="dialog-panel message-dialog">
  <div class="icon-close" [inlineSVG]="'/icons/icon-close.svg'" (click)="closeDialog()"></div>
  <div class="dialog-content">
    @if (loading) {
      <div class="spinner-container p-absolute">
        <mat-spinner class="primary" [diameter]="30"></mat-spinner>
      </div>
    }
    <form [ngClass]="{ 'v-hidden': loading }" [formGroup]="form" (submit)="onSubmit()">
      <div class="dialog-header">
        <h1 class="dialog-title dot">{{ 'marketplace.send_msg_dialog.send_msg' | transloco }}</h1>
      </div>
      <div class="dialog-body">
        <div class="form-field-container">
          <div class="form-field-label">
            {{ 'form.field.name' | transloco }}
          </div>
          <mat-form-field class="form-field" [floatLabel]="'auto'">
            <input matInput formControlName="name" required />
            @if (getFormControl('name').invalid) {
              <mat-error>
                @if (getFormControl('name').errors.required) {
                  {{ 'form.error.required' | transloco }}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="form-field-container">
          <div class="form-field-label">
            {{ 'form.field.message' | transloco }}
          </div>
          <mat-form-field class="form-field form-field-message" [floatLabel]="'auto'">
            <textarea
              matInput
              formControlName="text"
              cdkTextareaAutosize
              cdkAutosizeMinRows="6"
              cdkAutosizeMaxRows="10"
              maxlength="500"
              required
            ></textarea>
            @if (getFormControl('text').invalid) {
              <mat-error>
                @if (getFormControl('text').errors.required) {
                  {{ 'form.error.required' | transloco }}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="dialog-bottom">
        <button type="submit" class="btn btn-primary d-block w-100" [disabled]="form.invalid">
          {{ 'global.send' | transloco }}
        </button>
      </div>
    </form>
  </div>
</div>
